import { createRoot } from "react-dom/client";
import {
  Navigate,
  Outlet,
  RouterProvider,
  createHashRouter,
} from "react-router-dom";
import { loginRoutes } from "./login/route";
import { orderRoutes } from "./order/routes";
import { Root } from "./root";
import "./styles.css";

const router = createHashRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <div>Not Found</div>,
    children: [
      {
        index: true,
        element: <Navigate to={"login"} />,
      },
      {
        path: "login",
        element: <Outlet />,
        children: loginRoutes,
      },
      {
        path: "orders",
        element: <Outlet />,
        children: orderRoutes,
      },
    ],
  },
]);

const root = createRoot(document.getElementById("root"));
root.render(<RouterProvider router={router} />);
